<template>
  <div class="hezuo_page">
    <!-- 返回按钮 + 标题 -->
    <div class="nav_bar">
      <div class="back_btn" @click="goBack">‹</div>
      <div class="nav_title">商务合作</div>
    </div>
    <div class="img-div">

    </div>
    <div class="form_wrap">
      <div class="form_card">
        <div class="form_item">
          <div class="form_icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="#999" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" width="18" height="18"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>
          </div>
          <input
            v-model="form.name"
            class="form_input"
            type="text"
            placeholder="请输入您的姓名"
          />
        </div>
        <div class="form_item">
          <div class="form_icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="#999" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" width="18" height="18"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></svg>
          </div>
          <input
            v-model="form.address"
            class="form_input"
            type="text"
            placeholder="请输入您的地址"
          />
        </div>
        <div class="form_item">
          <div class="form_icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="#999" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" width="18" height="18"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/></svg>
          </div>
          <input
            v-model="form.phone"
            class="form_input"
            type="tel"
            maxlength="11"
            placeholder="请输入您的电话"
          />
        </div>
        <button class="submit_btn"  @click="handleSubmit">
          提交
        </button>
      </div>

      <div class="tips">提交后，工作人员将在 1 个工作日内与您联系</div>
    </div>

    <AdultNewTabBar />
  </div>
</template>

<script>
import axios from 'axios'
import AdultNewTabBar from '@/components/AdultNewTabBar.vue'

export default {
  name: 'NewPageHezuo',
  components: { AdultNewTabBar },
  data() {
    return {
      form: {
        name: '',
        region: '',
        phone: ''
      }
    }
  },
  computed: {
    isValidPhone() {
      return /^1\d{10}$/.test(this.form.phone.trim())
    },
    canSubmit() {
      return this.form.name.trim() && this.form.region.trim() && this.isValidPhone
    }
  },
  methods: {
    goBack() {
      this.$router.back()
    },
    async handleSubmit() {
      // if (!this.canSubmit) return
      if (!this.form.name.trim() || !this.form.address.trim() || !this.isValidPhone) {
        alert('请填写完整信息')
        return
      }
      try {
        const res = await axios.post(
          'https://htapi.zxznzy.com/project/h5_shangwu',
          {
            name: this.form.name,
            address: this.form.address,
            phone: this.form.phone
          }
        )
        if (res.data.code === 1) {
          alert('提交成功！工作人员将尽快与您联系')
          this.form = { name: '', address: '', phone: '' }
        } else {
          alert(res.data.message || '提交失败')
        }
      } catch (e) {
        console.error(e)
        alert('网络异常，请稍后重试')
      }
    }
  }
}
</script>

<style scoped>
.img-div {
  width: 100%;
  height: 200px;
  background: url('@/assets/new_adult_img/价格列表背景图.png') no-repeat center center;
  background-size: cover;
}
.hezuo_page {
  width: 100vw;
  min-height: 100vh;
  background: linear-gradient(180deg, #7fc8e8 0%, #3a8fd4 35%, #1a5fa6 100%);
  box-sizing: border-box;
  padding-bottom: 70px;
}

/* 顶部导航 */
.nav_bar {
  position: relative;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.back_btn {
  position: absolute;
  left: 14px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 28px;
  color: #fff;
  font-weight: 300;
  cursor: pointer;
  line-height: 1;
}
.nav_title {
  font-size: 16px;
  font-weight: 600;
  color: #fff;
}

/* 表单区 */
.form_wrap {
  padding: 0px 24px 0;
}
.form_card {
  background: #fff;
  border-radius: 14px;
  padding: 24px 20px 20px;
  box-shadow: 0 6px 20px rgba(0,0,0,0.15);
}
.form_item {
  margin-bottom: 18px;
  display: flex;
  align-items: center;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 0 12px;
  height: 44px;
}
.form_icon {
  width: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 10px;
  flex-shrink: 0;
}
.form_input {
  flex: 1;
  height: 100%;
  border: none;
  font-size: 15px;
  color: #333;
  outline: none;
  background: transparent;
}
.form_input::placeholder {
  color: #bbb;
}

.submit_btn {
  width: 100%;
  height: 46px;
  border: none;
  border-radius: 23px;
  background: linear-gradient(135deg, #5ca8e8, #1a5fa6);
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: opacity 0.2s;
}
.submit_btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.tips {
  text-align: center;
  font-size: 12px;
  color: rgba(255,255,255,0.8);
  margin-top: 16px;
}
</style>
